<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[headerIcon]="{fontIcon: 'fa-eye', fontSet: 'fad'}"
	[headerText]="data.mapping.name + (T.TRAINING_ROOM_RESTRICTION_DIALOG_TITLE | translate)"
	[matDialogData]="data"
	[rect]="rect"
>
	<ng-container dialogContent>
		<sim-room-chip-input
			[roomFc]="roomFc"
			[roomCapabilities]="RoomCapability.Training"
			[canSelectMultipleRooms]="true"
			[label]="T.TRAINING_ROOM_RESTRICTION_DIALOG_ROOM_NAME | translate"
		/>

		<sim-room-group-chip-input
			[roomGroupFc]="roomGroupFc"
			[canSelectMultipleRoomGroups]="true"
			[label]="T.CONFIGURATION_EDITOR_TRAINING_ROOM_GROUPS | translate"
		/>
	</ng-container>
	<ng-container actions>
		<sim-button
			(onClick)="saveRecorderMapping()"
			[color]="'accent'"
			[icon]="{fontSet: 'fad', fontIcon: 'fa-check'}"
			[label]="T.BUTTON_OK"
		/>
	</ng-container>
</sim-basic-material-dialog>
